import type React from 'react';

import { usePetitionUpdatePageData } from '#src/app/pages/petitionUpdate/details/pageContext';
import { MembershipAwarenessWithData } from '#src/app/shared/components/membership';

export const PageMembershipAwareness: React.FC<EmptyProps> = () => {
	const {
		data: {
			update: {
				petition: { id: petitionId, slug },
			},
			petitionSigned,
		},
	} = usePetitionUpdatePageData();

	return (
		<MembershipAwarenessWithData
			sourceLocation="petition_update"
			petitionId={petitionId}
			slug={slug}
			signed={petitionSigned}
		/>
	);
};
